import loadjs from "loadjs";
import getFrameParams from "./getUrlParams";
import * as caUtil from "@callApi";
import WindowFunc from "./window";
import getOs from "./getOsInfo";

const callApi = caUtil.callApi;

export const checkSSO = (path, checkCustom = true) => {
  return new Promise((rs, rj) => {
    if (!window.ssoChecked && !window.isAdminIndex) {
      if (/.*em_auth_code.*/.test(window.location.href)) {
        if (window.ssoChecking) {
          let interval = setInterval(() => {
            if (window.ssoChecking) {
              return;
            } else {
              clearInterval(interval);
              rs();
            }
          }, 500);
        } else {
          let params = getFrameParams();
          window.ssoChecking = true;
          callApi("/api/ec/dev/app/test", "GET", {
            em_auth_code: params["em_auth_code"],
            em_auth_userid: params["em_auth_userid"],
            timeZoneOffset: new Date().getTimezoneOffset(),
            ...params
          }).then(res => {
            window.ssoChecked = true;
            window.ssoChecking = false;
            window.em_url_open = res.em_url_open;
            if (res.emaccesstk) {
              window.localStorage["emaccesstk"] = res.emaccesstk;
            }
            if (res.languageType) {
              window.localStorage["languageidweaver"] = res.languageType;
            }

            if (!res.status) {
              window.location.href =
                `${window.ecologyContentPath || ""}` + "/wui/index.html";
              rs();
            } else {
              function initEm(res, rs) {
                setTimeout(() => {
                  //init emobile config
                  if (window.em) {
                    em.config({
                      corpId: res.em_corpid, //必填，企业的corpId
                      appId: "" // 非必填，应用ID
                    });
                    em.ready(() => {
                      window.localStorage.emobile_ec_id = res.ec_id;
                      em.setPageReload({
                        setvalue: 2, // 1表示每次都需要重新加载页面（默认） 2表示保持页面无需重新加载，
                        success: function(res) {
                          // 如：{"errMsg":"setHoldPage:ok"}
                          //alert(res.errMsg);
                        }
                      });
                    });
                    getOs(() => {
                      rs();
                    });
                  }
                }, 100);
              }
              let timestamp = new Date().getTime();
              let emUrl = res.em_url_open + "/open/js/jem.js?_key=" + timestamp;

              emUrl =
                window.location.protocol +
                "//" +
                window.location.host +
                "/open/js/jem.js?_key=" +
                timestamp;
              if (/wxExternalAddressEnable=1/.test(window.location.href)) {
                emUrl =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  "/open/js/jem.js?_key=" +
                  timestamp;
                window.localStorage["wxExternalAddressEnable"] = "1";
              } else {
                window.localStorage.removeItem("wxExternalAddressEnable");
              }
              loadjs.isDefined("em")
                ? loadjs.ready("em", initEm.bind(this, res, rs))
                : loadjs(emUrl, "em", initEm.bind(this, res, rs));
            }
          });
        }
      } else {
        if (checkCustom) {
          if (!window.e9ecComConfig) {
            if (
              window.e9ssoPCConfig &&
              window.e9ssoPCConfig.inUse &&
              window.e9ssoPCConfig.customInit
            ) {
              window.e9ssoPCConfig.customInit().then(() => {
                checkCustomSSO(path).then(() => {
                  getOs(() => {
                    rs();
                  });
                });
              });
            } else {
              checkCustomSSO(path).then(() => {
                getOs(() => {
                  rs();
                });
              });
            }
          } else {
            if (
              window.e9ssoPCConfig &&
              window.e9ssoPCConfig.inUse &&
              window.e9ssoPCConfig.customInit
            ) {
              window.e9ssoPCConfig.customInit().then(() => {
                checkCustomSSO(path).then(() => {
                  getOs(() => {
                    rs();
                  });
                });
              });
            } else {
              checkCustomSSO(path).then(() => {
                getOs(() => {
                  rs();
                });
              });
            }
          }
        } else {
          getOs(() => {
            rs();
          });
        }
      }
    } else {
      getOs(() => {
        rs();
      });
    }
  });
};
export const checkCustomSSO = path => {
  return new Promise((rs, rj) => {
    if (!window.ssoCustomChecked && !window.isAdminIndex) {
      window.ssoCustomChecked = true;
      if (window.customSSOConfig) {
        if (window.customSSOConfig.inUse) {
          let params = getFrameParams();
          let checkSessionParams = {};
          if (window.customSSOConfig.sessionCheckApiParams) {
            let sessionParams = window.customSSOConfig.sessionCheckApiParams.split(
              ","
            );
            sessionParams.forEach(element => {
              checkSessionParams[element] = params[element];
            });
          }
          callApi(
            window.customSSOConfig.sessionCheckApi,
            window.customSSOConfig.sessionCheckApiType || "GET",
            checkSessionParams
          ).then(res => {
            if (res.status && !res.hasSession) {
              let servicePath =
                path ||
                window.location.pathname +
                  window.location.search +
                  window.location.hash;
              if (/\/wui\/index\.html\#\/\?/.test(servicePath)) {
                servicePath = "/wui/index.html#/main";
              }
              if (
                /\/spa\/portal\/public\/index\.html#\/licensesubmit\?display=page/.test(
                  window.location.href
                )
              ) {
                rs();
              }
              function getQueryVariable(variable) {
                var query = window.location.search.substring(1);
                var vars = query.split("&");
                for (var i = 0; i < vars.length; i++) {
                  var pair = vars[i].split("=");
                  if (pair[0] == variable) {
                    return pair[1];
                  }
                }
                return false;
              }
              let service =
                window.location.protocol +
                "//" +
                window.location.host +
                (window.ecologyContentPath || "") +
                "/wui/cas-entrance.jsp?path=" +
                encodeURIComponent(servicePath);
              if (getQueryVariable("languid")) {
                service =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  (window.ecologyContentPath || "") +
                  "/wui/cas-entrance.jsp?languid=" +
                  getQueryVariable("languid") +
                  "&path=" +
                  encodeURIComponent(servicePath);
              }
              let paramsMark = "?";
              if (window.customSSOConfig.serverLoginUrl.indexOf("?") !== -1) {
                paramsMark = "&";
              }
              window.localStorage["casPath"] = `${
                window.customSSOConfig.serverLoginUrl
              }${paramsMark}service=${encodeURIComponent(service)}`;
              window.location.href = `${
                window.customSSOConfig.serverLoginUrl
              }${paramsMark}service=${encodeURIComponent(service)}`;
              // window.location.href = service;
              rs();
            } else {
              if (res.status && res.hasSession) {
                if (
                  /.*\/login\/OALogin\.jsp.*/.test(
                    WindowFunc.getTop().location.href
                  ) ||
                  /.*\/wui\/index(-admin)?\.html.*#\/\?.*/.test(
                    WindowFunc.getTop().location.href
                  ) ||
                  /.*\/wui\/index(-admin)?\.html$/.test(
                    WindowFunc.getTop().location.href
                  )
                ) {
                  // 第三方集成登录的场景下 登录页如果系统session还未清除 则自动跳转
                  WindowFunc.getTop().location.href =
                    `${window.ecologyContentPath || ""}` +
                    "/wui/index.html#/main";
                }
              }
              getOs(() => {
                rs();
              });
            }
          });
        } else {
          getOs(() => {
            rs();
          });
        }
      } else {
        getOs(() => {
          rs();
        });
      }
    } else {
      getOs(() => {
        rs();
      });
    }
  });
};

export const ssoLogout = logoutRes => {
  if (window.eventRegister.list["emLogoutEvent"]) {
    window.eventRegister.startList(
      "emLogoutEvent",
      () => {
        // success
      },
      () => {
        // fail
      }
    );
  } else {
    getLogoutUrl(logoutRes);
  }
};

const getLogoutUrl = (logoutRes, isEngine) => {
  if (logoutRes.status == true) {
    if (window.customSSOConfig && window.customSSOConfig.inUse) {
      if (window.customSSOConfig.serverLogoutUrl) {
        if (window.customSSOConfig.serverLogoutAjax) {
          // TODO
        } else {
          window.location.href = window.customSSOConfig.serverLogoutUrl;
        }
      } else {
        if (window.weaHistory && location.href.indexOf("engine.html") == -1) {
          window.weaHistory.push({
            pathname: "/"
          });
        } else {
          window.location.href =
            `${window.ecologyContentPath || ""}` + "/wui/index.html";
        }
      }
    } else {
      if (logoutRes.casLogoutUrl) {
        let split = "?";
        if (logoutRes.casLogoutUrl.indexOf("?") > -1) {
          split = "&";
        }
        window.location.href =
          logoutRes.casLogoutUrl +
          split +
          "e9timestamp=" +
          new Date().getTime();
      } else {
        if (window.weaHistory && location.href.indexOf("engine.html") == -1) {
          window.weaHistory.push({
            pathname: "/"
          });
        } else {
          window.location.href =
            `${window.ecologyContentPath || ""}` + "/wui/index.html";
        }
      }
    }
  }
};

window.onLogoutCallback = function() {
  window.localStorage["e9_locale"] = null;
  window.ssoChecked = false;
  window.e9_locale = null;

  if (window.emClient) {
    emClient.logout();
  }
};



// WEBPACK FOOTER //
// ./ecology9/wea-tools/checkSSO.js